<template>
  <div class="flex relate">
    <div class="layout">
      <div class="log-icon">
        <span>{{log.items[0].participantName&&log.items[0].participantName[0]}}</span>
        <slot name="badge"/>
      </div>
      <div class="flex log-content">
        <div class="log-node-name">{{log.name}} </div>
        <div class="log-participant">{{participant}}</div>
        <div class="log-opinion" v-if="log.items[0].opinion">"{{log.items[0].opinion}}"</div>
      </div>
      <div class="log-date">
        {{date}}
      </div>
    </div>
<!--    <field :readonly="true" v-if="log.items[0].files && log.items[0].files.length" :value="log.items[0].files"-->
<!--           field="relate"/>-->
  </div>
</template>

<script>
  import CacheService from "@/service/catch";
  import {EInstanceState} from "../instance";
  // import Field from "../../field/field";
  import {InstanceService} from "../instance";
  import {Message} from "@maidi/common";

  export default {
    name: "log-user",
    props: ["log"],
    // components: {Field},
    data() {
      return {reminded: false};
    },
    computed: {
      participant() {
        let participant = "";
        const me = CacheService.get('user');
        if (this.log.items[0].participant === me.userID) {
          participant = "我";
        }
        else {
          participant = this.log.items[0].participantName;
        }
        if (this.log.state === EInstanceState.Forward) {
          participant += "（已转交）";
        }
        else if (this.log.state === EInstanceState.Processing) {
          participant += "（审批中）";
        }
        else if (this.log.state === EInstanceState.Failed) {
          participant += "（已拒绝）";
        }
        else if (this.log.state === EInstanceState.Revoke) {
          participant += "（已撤销）";
        }
        return participant;
      },
      date() {
        if (!this.log.items[0].opDate) {
          return "";
        }
        return this.log.items[0].opDate.replace(/^\d{4}-(\d{2}-\d{2})\D+(\d{2}:\d{2}):\d{2}.*$/g, "$1 $2");
      },
      me() {
        const me = CacheService.get('user');
        return me && me.userID;
      },
    },
    methods: {

    },
  }
</script>

<style scoped lang="scss">
  @import "../../../../assets/css/global";

  .reminder {
    margin-left: 10px;
    font-size: 1.3rem;
    color: $color-primary;
    cursor: pointer;
  }

  .relate {
    flex-direction: column;
  }

  .log-opinion {
    color: $color-font-light;
    font-size: 1.2rem;
  }
</style>
